import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View
} from '@react-pdf/renderer'

Font.register({
  family: 'Open Sans',
  fonts: [
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf'
    },
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
      fontWeight: 600
    },
    {
      src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf',
      fontWeight: 800
    }
  ]
})

const styles = StyleSheet.create({
  pageBeam: {
    paddingLeft: 30,
    paddingRight: 30,
    paddingTop: 20,
    paddingBottom: 20
  },
  pageSlot: {
    padding: 0
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse'
  },
  rowBeamCenter: {
    flexDirection: 'row',
    justifyContent: 'center'
  },
  rowBeam: {
    flexDirection: 'row',
    width: '100%',
    marginLeft: 54
  },
  rowSlot: {
    flexDirection: 'row'
  },
  cellSlot: {
    width: '50%',
    textAlign: 'center',
    verticalAlign: 'middle',
    border: '0.5px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  cellBeam: {
    width: '40%',
    textAlign: 'center',
    verticalAlign: 'middle',
    borderTop: '0.5px solid black',
    borderBottom: '0.5px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  cellEven: {
    borderRight: '0.5px solid black'
  },
  qrImage: {
    width: 120,
    height: 120
  },
  qrTextWrapper: {
    width: '100%',
    borderTop: '0.5px solid black',
    marginTop: 10,
    paddingTop: 5
  },
  qrTextWrapperBackground: {
    width: '100%',
    borderTop: '0.5px solid black',
    marginTop: 10,
    paddingTop: 5,
    backgroundColor: 'cyan'
  },
  qrText: {
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'Open Sans',
    fontWeight: 800
  },
  qrImageA3: {
    width: 175,
    height: 175
  },
  qrTextA3: {
    textAlign: 'center',
    fontSize: 22,
    fontFamily: 'Open Sans',
    fontWeight: 800
  },
  pageA3: {
    padding: 0,
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  rowA3: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '29cm'
  },
  cellA3: {
    width: '14.5cm',
    height: '8cm',
    textAlign: 'center',
    verticalAlign: 'middle',
    border: '0.5px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  qrImagePallet: {
    width: 215,
    height: 215,
    marginTop: 0
  },
  qrTextPallet: {
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'Open Sans',
    fontWeight: 800
  },
  rowPallet: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: 841.89
  },
  cellPallet: {
    width: 280.63,
    height: 238.11,
    textAlign: 'center',
    verticalAlign: 'middle',
    border: '0.5px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  qrTextWrapperPallet: {
    width: '100%',
    borderTop: '0.5px solid black',
    marginTop: 2,
    paddingTop: 2
  }
})
const Pdf = ({ data, typeDownload = null }) => {
  const isA3 =
    typeDownload === 'beam' ||
    typeDownload === 'slot' ||
    typeDownload === 'pallet'
  const isPallet = typeDownload === 'pallet'
  const itemsPerRow = isPallet ? 3 : 2
  const itemsPerPage = isPallet ? 15 : 10
  const renderPage = (rows) => (
    <Page
      size={isA3 ? 'A3' : 'A4'}
      wrap={false}
      style={
        isA3
          ? styles.pageA3
          : typeDownload === 'beam'
            ? styles.pageBeam
            : styles.pageSlot
      }
    >
      {rows.map((row, rowIndex) => (
        <View
          key={`row-${rowIndex}`}
          style={
            isPallet
              ? styles.rowPallet
              : isA3
                ? styles.rowA3
                : typeDownload === 'beam'
                  ? row.length === 2
                    ? styles.rowBeamCenter
                    : styles.rowBeam
                  : styles.rowSlot
          }
        >
          {row.map((colItem, colIndex) => (
            <View
              key={`col-${colIndex}`}
              style={[
                isPallet
                  ? styles.cellPallet
                  : isA3
                    ? styles.cellA3
                    : typeDownload === 'beam'
                      ? styles.cellBeam
                      : styles.cellSlot,
                !isA3 && typeDownload === 'beam' && colIndex % 2 === 0
                  ? styles.cellEven
                  : null
              ]}
            >
              <View>
                <Image
                  src={colItem.qr}
                  style={
                    isPallet
                      ? styles.qrImagePallet
                      : isA3
                        ? styles.qrImageA3
                        : styles.qrImage
                  }
                />
              </View>
              <View
                style={
                  isPallet
                    ? styles.qrTextWrapperPallet
                    : typeDownload === 'beam'
                      ? styles.qrTextWrapperBackground
                      : styles.qrTextWrapper
                }
              >
                <View style={{ marginBottom: isPallet ? 2 : 5 }}>
                  <Text
                    style={
                      isPallet
                        ? styles.qrTextPallet
                        : isA3
                          ? styles.qrTextA3
                          : styles.qrText
                    }
                  >
                    {colItem?.name || colItem?.current_location}
                  </Text>
                </View>
              </View>
            </View>
          ))}
        </View>
      ))}
    </Page>
  )

  const pages = []
  let currentPageRows = []
  let currentRow = []

  data.forEach((rowItem) => {
    rowItem.forEach((colItem) => {
      currentRow.push(colItem)

      if (currentRow.length === itemsPerRow) {
        currentPageRows.push(currentRow)
        currentRow = []
      }

      if (currentPageRows.length === itemsPerPage / itemsPerRow) {
        pages.push(renderPage(currentPageRows))
        currentPageRows = []
      }
    })
  })

  if (currentRow.length > 0) {
    currentPageRows.push(currentRow)
  }

  if (currentPageRows.length > 0) {
    pages.push(renderPage(currentPageRows))
  }

  return <Document>{pages}</Document>
}

export default Pdf
